var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container feedback template-bg-gray" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec" },
        [
          _c(
            "div",
            {
              staticClass:
                "loop_container bg-transparent update-request-form-common"
            },
            [
              _c("div", { staticClass: "card form-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "feedback_container feedback_newupdate" },
                  [
                    _vm.logoURL
                      ? _c("div", { staticClass: "community-logo" }, [
                          _c("img", {
                            staticClass: "top-logo custom-logo",
                            attrs: { src: _vm.logoURL, alt: "Community Logo" }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSubmitted
                      ? _c(
                          "div",
                          {
                            staticClass: "common-space-from-logo my-text-center"
                          },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "template-title-feedback",
                                attrs: {
                                  id: "main-header",
                                  "aria-live": "polite"
                                }
                              },
                              [_vm._v(_vm._s(_vm.pageTitle))]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "common-space-from-logo my-text-center"
                          },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "template-title-feedback",
                                attrs: {
                                  id: "main-header",
                                  "aria-live": "polite"
                                }
                              },
                              [_vm._v("Thank You!")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "custom-content my-text-center",
                                attrs: { "aria-live": "polite" }
                              },
                              [
                                _vm._v(
                                  "We really appreciate your\n                                feedback!"
                                )
                              ]
                            )
                          ]
                        ),
                    _vm._v(" "),
                    !_vm.isSubmitted
                      ? _c(
                          "form",
                          {
                            staticClass: "template-form",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.submitFeedback()
                              }
                            }
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2",
                                    class: [
                                      { "b-error": _vm.errors.has("comment") },
                                      "form-group",
                                      "pd-remove",
                                      "unsubscribe-height"
                                    ]
                                  },
                                  [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.comment,
                                          expression: "comment"
                                        }
                                      ],
                                      staticClass:
                                        "form-control placeholder-bold",
                                      class: {
                                        "request-form-error-border": _vm.errors.has(
                                          "description"
                                        )
                                      },
                                      attrs: {
                                        "aria-label":
                                          "Character count available for this textarea",
                                        id: "textarea",
                                        name: "comment",
                                        rows: "10",
                                        required: "",
                                        "aria-required": "true"
                                      },
                                      domProps: { value: _vm.comment },
                                      on: {
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.comment = $event.target.value
                                          },
                                          function(e) {
                                            return (_vm.comment = _vm.sanitizeInput(
                                              e.target.value
                                            ))
                                          }
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "form-group pd-remove unsubscribe-btn mb-0-custom"
                                    })
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12 text-right" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group pd-remove unsubscribe-btn"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn_info template-review-submit template-button-width feedback-button",
                                          style: _vm.reviewBtn,
                                          attrs: {
                                            type: "submit",
                                            name: "helpAction"
                                          }
                                        },
                                        [_vm._v("Submit")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSubmitted
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isAskAnalysis,
                                expression: "isAskAnalysis"
                              }
                            ],
                            staticClass: "m-top-34"
                          },
                          [
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "email-request-review" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "template-request-review" },
                                    [
                                      _vm.ask.analysis
                                        ? _c(
                                            "p",
                                            { staticClass: "font-color" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.ask.analysis.summary
                                                    .summary_of_results
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "email-request-review" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "template-request-review" },
                                    [
                                      _vm.ask.createdByMemberID &&
                                      _vm.ask.createdByMemberID.first &&
                                      _vm.ask.createdByMemberID.last
                                        ? _c(
                                            "span",
                                            { attrs: { id: "feedback-name" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.ask.createdByMemberID
                                                    .first +
                                                    " " +
                                                    _vm.ask.createdByMemberID
                                                      .last
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _vm.ask.createdByMemberID &&
                                      _vm.$lodash.has(
                                        _vm.ask.createdByMemberID.emails,
                                        0
                                      )
                                        ? _c(
                                            "span",
                                            { attrs: { id: "feedback-email" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.ask.createdByMemberID
                                                    .emails[0]
                                                ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("br"),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { attrs: { id: "feedback-name" } },
                                        [_vm._v(_vm._s(_vm.ask.subject))]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "font-color" }, [
                                        _vm._v(_vm._s(_vm.ask.text))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-inline text-center footer-links" },
                [
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.landingPageURL &&
                    _vm.community.content.landingPageURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.landingPageURL,
                              target: "_blank",
                              tabindex: "0"
                            }
                          },
                          [_vm._v("Learn More")]
                        )
                      : _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)", tabindex: "0" }
                          },
                          [_vm._v("Learn More")]
                        )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.termsConditionsURL &&
                    _vm.community.content.termsConditionsURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.termsConditionsURL,
                              target: "_blank",
                              tabindex: "0"
                            }
                          },
                          [_vm._v("Terms Of Use [pdf]")]
                        )
                      : _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)", tabindex: "0" }
                          },
                          [_vm._v("Terms Of Use [pdf]")]
                        )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.unsubscribePageURL &&
                    _vm.community.content.unsubscribePageURL.length
                      ? _c(
                          "a",
                          {
                            attrs: {
                              tabindex: "0",
                              href: _vm.community.content.unsubscribePageURL,
                              target: "_blank"
                            }
                          },
                          [_vm._v("Opt\n                            Out")]
                        )
                      : _c("a", { attrs: { href: "javascript:void(0)" } }, [
                          _vm._v("Opt Out")
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unsubscribe-community-logo" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        (_vm.community.content &&
                          _vm.community.content.landingPageURL) ||
                        "https://www.protopia.co",
                      target: "_blank"
                    }
                  },
                  [
                    _vm.community.content
                      ? _c("img", {
                          attrs: {
                            src: _vm.footerLogoURL,
                            alt:
                              "Community Logo of " +
                              _vm.community.content.parameter4
                          }
                        })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("Protopia - Visit our site")
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "required-note template-label",
        attrs: { id: "required-note" }
      },
      [
        _vm._v(
          "\n                                Fields marked with an asterisk ("
        ),
        _c("span", { staticClass: "required-symbol" }, [_vm._v("*")]),
        _vm._v(
          ") are\n                                required.\n                            "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h2", { staticClass: "text-center email-request-title" }, [
          _vm._v("Our recommendation")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h3", { staticClass: "text-center email-request-title" }, [
          _vm._v("FYI, here's the request")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bd9eefa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd9eefa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackView.vue
// module id = null
// module chunks = 